import type { TOC } from '@ember/component/template-only';
import { PrismBreadcrumb, PrismButton } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import SettingsCustomPropertyTagsModalsModalDefinition from 'lumen/components/settings/custom-property-tags/modals/modal-definition';
import SettingsCustomPropertyTagsModalsModalDeleteDefinition from 'lumen/components/settings/custom-property-tags/modals/modal-delete-definition';
import SettingsCustomPropertyTagsTableDefinitions from 'lumen/components/settings/custom-property-tags/table-definitions';
import SettingsPageTemplate from 'lumen/components/settings/page-template';
import type MarketSettingsPropertyTagsCustomController from 'lumen/controllers/market/settings/property-tags/custom';
import type { CustomTagsRouteModel } from 'lumen/routes/market/settings/property-tags/custom';

interface MarketSettingsPropertyTagsCustomSignature {
  Args: {
    controller: MarketSettingsPropertyTagsCustomController;
    model: CustomTagsRouteModel;
  };
}

<template>
  <SettingsPageTemplate
    @description={{t "settings.property_tags.custom_tags.description"}}
    @title={{t "settings.property_tags.custom_tags.title"}}
  >
    <:breadcrumb>
      <PrismBreadcrumb as |B|>
        <B.item
          @label={{t "settings.property_tags.title"}}
          @route="market.settings.property-tags.index"
        />
        <B.item
          @isCurrent={{true}}
          @label={{t "settings.property_tags.custom_tags.title"}}
        />
      </PrismBreadcrumb>
    </:breadcrumb>
    <:headerAfter>
      <PrismButton
        @iconBefore="plus"
        @isDisabled={{@controller.isAtDefinitionLimit}}
        @label={{t "settings.property_tags.custom_tags.create_tag"}}
        @onClick={{@controller.openCreateModal}}
        data-test-id="create-definition-button"
      />
    </:headerAfter>
    <:default>
      <SettingsCustomPropertyTagsTableDefinitions
        @definitions={{@controller.definitions}}
        @isLoading={{@controller.model.definitions.isRunning}}
        @onDelete={{@controller.openDeleteModal}}
        @onEdit={{@controller.openEditModal}}
      />
    </:default>
  </SettingsPageTemplate>

  {{#if @controller.definitionBeingEdited}}
    <SettingsCustomPropertyTagsModalsModalDefinition
      @definition={{@controller.definitionBeingEdited}}
      @isNameUnique={{@controller.isNameUnique}}
      @onClose={{@controller.closeEditModal}}
      @onSuccess={{@controller.onDefinitionSaved}}
    />
  {{/if}}

  {{#if @controller.definitionBeingDeleted}}
    <SettingsCustomPropertyTagsModalsModalDeleteDefinition
      @definition={{@controller.definitionBeingDeleted}}
      @onClose={{@controller.closeDeleteModal}}
      @onSuccess={{@controller.onDefinitionDeleted}}
    />
  {{/if}}
</template> satisfies TOC<MarketSettingsPropertyTagsCustomSignature>;
